// extracted by mini-css-extract-plugin
export default {"tabs":"JHwJFiK09b","icon":"g7DjZw7YgK","divider":"NAXzBz5Ob2"};